import { render, staticRenderFns } from "./CollectionAgingTransaction.vue?vue&type=template&id=5d1d6401&scoped=true&"
import script from "./CollectionAgingTransaction.vue?vue&type=script&lang=ts&"
export * from "./CollectionAgingTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionAgingTransaction.vue?vue&type=style&index=0&id=5d1d6401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d6401",
  null
  
)

export default component.exports